import { VizitLogoMark } from '@vizit/icons';
import { RouterLink } from '@vizit/molecules';

interface VerticalNavbarLogoProps {
  to?: string;
  'aria-label'?: string;
}

function VerticalNavbarLogo(props: VerticalNavbarLogoProps) {
  const { to = '/', 'aria-label': ariaLabel = 'Vizit Home' } = props;

  return (
    <RouterLink aria-label={ariaLabel} to={to}>
      <VizitLogoMark className="text-gray-utility-900" width={24} height={24} />
    </RouterLink>
  );
}

export { VerticalNavbarLogo };
export type { VerticalNavbarLogoProps };
